import { render, staticRenderFns } from "./footer-message.vue?vue&type=template&id=21492658"
import script from "./footer-message.vue?vue&type=script&lang=js"
export * from "./footer-message.vue?vue&type=script&lang=js"
import style0 from "./footer-message.vue?vue&type=style&index=0&id=21492658&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports